const hasRole = (userRoles, routePermission) =>
  userRoles.includes(routePermission);

const RouteGuard = ({ userRoles, routePermission, children }) => {
  if (!hasRole(userRoles, routePermission)) {
    return <div>Access denied</div>;
  }

  return <>{children}</>;
};

export default RouteGuard;
